export default __webpack_public_path__ + "static/logo_rose_associates-12398b1ae4cc31e28a10702134e26f99.png";